import {
  Box,
  LinearProgress,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import usePostData from "../../../utility/usePostData";

const AnnonceListe = () => {
  const { data, isLoading, paginate, refreshSearch } =
    useFetchDataWithPagination("annonces");
  const [annonces, setAnnonces] = useState(null);
  const { submitData } = usePostData();

  useEffect(() => {
    if (data?.data) {
      setAnnonces(data?.data.data);
    }
  }, [data]);

  const deleteAnnoce = (e) => {
    const response = window.confirm("êtes-vous sûr ? ");
    if (response) {
      submitData("annonces/" + e, null, "DELETE");
      refreshSearch();
    }
  };

  return (
    <Box sx={{ width: "95%", margin: "auto", mt: 3 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        {isLoading && (
          <LinearProgress
            sx={{
              backgroundColor: "#e0e0e0",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#00a652",
              },
            }}
          />
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#00a652",
              fontWeight: 500,
            }}
          >
            Liste des annonces
          </Typography>

          <Button
            component={Link}
            to="/annonce-add"
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: "#00a652",
              "&:hover": { backgroundColor: "#008c46" },
            }}
          >
            Ajouter une annonce
          </Button>
        </Box>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#00a652" }}>
                <TableCell sx={{ color: "white", fontWeight: 500 }}>
                  #
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 500 }}>
                  Titre
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: 500 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {annonces &&
                annonces.map((annonce, index) => (
                  <TableRow
                    key={annonce.id}
                    hover
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(0,166,82,0.04) !important",
                      },
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{annonce.title}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => deleteAnnoce(annonce.id)}
                        sx={{
                          color: "#ec1a20",
                          "&:hover": {
                            backgroundColor: "rgba(236,26,32,0.04)",
                          },
                        }}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
          {paginate()}
        </Box>
      </Paper>
    </Box>
  );
};

export default AnnonceListe;
